import { render } from "./CadastroTelasInstitucionalView.vue?vue&type=template&id=289b771d"
import script from "./CadastroTelasInstitucionalView.vue?vue&type=script&lang=js"
export * from "./CadastroTelasInstitucionalView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\SGCAD24\\Desenvolvimento\\Corofergs\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__